import React, { Component } from "react";
import { connect } from "react-redux";
import { changeAuth, reloadUser } from "../../containers/Auth/actions";
import { refreshAuthToken } from "../../index";

class AuthRequire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecking: true,
      hasTriedRefresh: false,
    };
  }

  async componentDidMount() {
    await this.verifyAuthenticated();
  }

  async verifyAuthenticated() {
    const { authenticated, token, dispatch } = this.props;
    const { hasTriedRefresh } = this.state;
    
    if (authenticated && token) {
      this.setState({ isChecking: false });
      return;
    }
    
    if (token && !authenticated) {
      dispatch(changeAuth(true));
      dispatch(reloadUser(true));
      this.setState({ isChecking: false });
      return;
    }

    if (!token && !hasTriedRefresh) {
      this.setState({ hasTriedRefresh: true });
      try {
        const { token } = await 
        refreshAuthToken();
        
        if (token) {
          dispatch(changeAuth(true));
          dispatch(reloadUser(true));
          this.setState({ isChecking: false });
          return;
        }
      } catch (error) {
        console.error("Failed to refresh token:", error);
      }
      
      this.setState({ isChecking: false });
      dispatch(changeAuth(false));
      document.location.href = "/login";
      return;
    }
    
    this.setState({ isChecking: false });
  }

  render() {
    const { isChecking } = this.state;
    const { authenticated, children, ...props } = this.props;

    if (isChecking) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div>
            <img src="/images/favicon-32x32.png" alt="Carregando..." />
          </div>
        </div>
      );
    }

    if (!authenticated) {
      return null;
    }

    const ComposedComponent = React.cloneElement(children, { ...props });
    return ComposedComponent;
  }
}

AuthRequire = connect(
  (state) => ({
    authenticated: state.auth.authenticated,
    token: state.auth.token,
    invited: state.auth.invited,
    firstTime: state.auth.firstTime,
    user: state.auth.user,
  }),
  (dispatch) => ({ dispatch })
)(AuthRequire);

export default AuthRequire;